// extracted by mini-css-extract-plugin
module.exports = {"toast":"useSelectiveComparison_toast__bAinc","hideToast":"useSelectiveComparison_hideToast__6WwyX","toastBar":"useSelectiveComparison_toastBar__SPFj6"};